if (!customElements.get('slider-component')) {
  class SliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.currentPageElement = this.querySelector('.slider-counter--current');
      this.pageTotalElement = this.querySelector('.slider-counter--total');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');

      if (!this.slider || !this.prevButton || !this.nextButton) {
        return;
      }

      this.initPages();

      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(this.initPages.bind(this));
        this.resizeObserver.observe(this.slider);
      } else {
        window.addEventListener('resize', this.initPages.bind(this));
      }

      this.slider.addEventListener('scroll', this.update.bind(this), { passive: true });
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
      this.slider.addEventListener('click', this.onSlideClick.bind(this));
    }

    setActiveSlide(activeIndex) {
      var safeIndex = Math.max(0, Math.min(activeIndex, this.sliderItemsToShow.length - 1));

      this.sliderItemsToShow.forEach(function (item, index) {
        var isActive = index === safeIndex;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      this.activeSlide = this.sliderItemsToShow[safeIndex] || null;
    }

    syncBitStudioOverlayTarget() {
      if (!this.activeSlide || !window.BitStudioInstances || !Array.isArray(window.BitStudioInstances.tryons)) {
        return;
      }

      var activeMediaId = this.activeSlide.dataset.mediaId || '';
      var activeMedia = this.activeSlide.querySelector('img, video');
      var activeMediaUrl = '';

      if (activeMedia) {
        if (activeMedia.tagName === 'IMG') {
          activeMediaUrl = activeMedia.currentSrc || activeMedia.getAttribute('src') || '';
        } else {
          activeMediaUrl = activeMedia.getAttribute('poster') || activeMedia.getAttribute('src') || '';
        }
      }

      var hostGallery = this.closest('[data-product-gallery]');
      var galleryWrapper = this.closest('.product-gallery');

      window.BitStudioInstances.tryons.forEach(function (instance) {
        if (!instance || typeof instance !== 'object' || typeof instance.isOverlayMode !== 'function' || !instance.isOverlayMode()) {
          return;
        }

        if (!instance.container || !hostGallery || !hostGallery.contains(instance.container)) {
          return;
        }

        instance.primaryMediaId = activeMediaId;
        instance.primaryMediaUrl = activeMediaUrl || instance.primaryMediaUrl;
        instance.overlayTargetSelector = '.product-gallery';
        instance.container.dataset.primaryMediaId = activeMediaId;
        instance.container.dataset.overlayTargetSelector = '.product-gallery';

        if (galleryWrapper && activeMediaId) {
          galleryWrapper.dataset.mediaId = activeMediaId;
        }

        if (activeMediaUrl) {
          instance.container.dataset.primaryMediaUrl = activeMediaUrl;
        }

        if (typeof instance.scheduleOverlayPlacementRefresh === 'function') {
          instance.scheduleOverlayPlacementRefresh();
        } else if (typeof instance.refreshOverlayPlacement === 'function') {
          instance.refreshOverlayPlacement();
        }
      });
    }

    initPages() {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.sliderItemsToShow = Array.prototype.slice.call(this.sliderItems).filter(function (element) {
        return element.clientWidth > 0;
      });

      if (this.sliderItemsToShow.length < 2) {
        if (this.currentPageElement) {
          this.currentPageElement.textContent = '1';
        }
        if (this.pageTotalElement) {
          this.pageTotalElement.textContent = String(this.sliderItemsToShow.length || 1);
        }
        if (this.prevButton) {
          this.prevButton.setAttribute('disabled', 'disabled');
        }
        if (this.nextButton) {
          this.nextButton.setAttribute('disabled', 'disabled');
        }
        if (this.sliderItemsToShow.length > 0) {
          this.setActiveSlide(0);
        }
        return;
      }

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.max(
        1,
        Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset)
      );
      this.totalPages = Math.max(1, this.sliderItemsToShow.length - this.slidesPerPage + 1);
      this.update();
    }

    update() {
      if (!this.slider || !this.sliderItemOffset) {
        return;
      }

      var previousPage = this.currentPage;
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
      this.setActiveSlide(this.currentPage - 1);
      this.syncBitStudioOverlayTarget();

      if (this.currentPageElement) {
        this.currentPageElement.textContent = String(this.currentPage);
      }

      if (this.pageTotalElement) {
        this.pageTotalElement.textContent = String(this.totalPages);
      }

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }

      if (this.currentPage !== previousPage) {
        this.dispatchEvent(
          new CustomEvent('slideChanged', {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.activeSlide
            }
          })
        );
      }
    }

    isSlideVisible(element) {
      var lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft;
      return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }

    onSlideClick(event) {
      var slide = event.target.closest('.product-gallery__item');
      if (!slide || slide.classList.contains('is-active')) {
        return;
      }

      var index = Array.prototype.indexOf.call(this.sliderItemsToShow, slide);
      if (index < 0) {
        return;
      }

      this.setActiveSlide(index);
      this.syncBitStudioOverlayTarget();
    }

    onButtonClick(event) {
      event.preventDefault();

      var position = event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + this.sliderItemOffset
        : this.slider.scrollLeft - this.sliderItemOffset;

      this.slider.scrollTo({
        left: position,
        behavior: 'smooth'
      });
    }
  }

  customElements.define('slider-component', SliderComponent);
}

document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('[data-site-header]');
  var toggle = document.querySelector('[data-menu-toggle]');

  if (header && toggle) {
    toggle.addEventListener('click', function () {
      var isOpen = header.classList.toggle('is-menu-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }
});
